import styled from 'styled-components';
import { Button, InfoBox, StyledGrid, StyledSpinner } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledContainer = styled(StyledGrid)`
  margin-top: 2.4rem;

  && {
    gap: 0;
  }
`;
export const StyledMitreTagsContainer = styled.div`
  border-right: 0.1rem solid ${({ theme }) => theme.colors.border.light};
  padding-right: 1.6rem;
  margin-right: 1.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border.light};
    border-right: 0;
    padding-right: 0;
    margin-right: 0;

    padding-bottom: 1.6rem;
    margin-bottom: 1.6rem;
  }
`;

export const StyledTagsHeading = styled.p`
  font-size: 1.8rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 1.6rem;
`;

export const StyledTagDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

export const StyledBrowseContainer = styled.div``;

export const StyledBrowseCategoriesWrapper = styled.div`
  margin-top: 1.6rem;
  margin-bottom: 0.6rem;
  max-height: 58.3rem;
  height: 100%;
  overflow-y: scroll;
  padding-right: 0.5rem;
`;

export const StyledSearchIcon = styled(FontAwesomeIcon)<{ isDarkMode: boolean }>`
  && {
    color: ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.grey[400] : theme.colors.grey[700])};
  }
`;

export const StyledInfoBox = styled(InfoBox)`
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
`;

export const StyledFindText = styled.p`
  text-align: center;
`;

export const StyledLine = styled.div`
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.grey[300]};
`;

export const StyledUpdateRoomButtonContainer = styled.div`
  margin-top: 2.4rem;
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const StyledTagsSelector = styled.div`
  font-size: 1.6rem;
  display: flex;
  flex-direction: column;
`;

export const StyledTagSelectors = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledLoader = styled(StyledSpinner)`
  width: 5rem;
  height: 5rem;
`;

export const StyledLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10rem;
  margin-bottom: 10rem;
`;

export const StyledCreateTagButton = styled(Button)`
  & {
    width: 100%;
    padding: 8px 12px;
    justify-content: flex-start;
    font-size: 1.6rem;
    font-family: 'Source Sans Pro';
  }
`;
